module.exports = __webpack_public_path__ + "img/reinscription.a7f02291.png";